/*
 * Copyright (c) 2017-present, flop! contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 * https://framagit.org/flopedt/flopedt
 */

import type { BodyOf, ResponseOf } from './core/schema.utils.d.ts'

import { Preferences } from '@/ts/entities/preferences.ts'
import { User } from '@/ts/entities/user.ts'
import { del, post } from './core/http.ts'

export type APILoginBody = BodyOf<'v1/auth/login', 'post'>
export type APILoginData = ResponseOf<'v1/auth/login', 'post', 200>

export async function login(body: APILoginBody) {
  const data = await post<APILoginData>('/api/v1/auth/login', body)

  return {
    authenticatedUser: User.fromJSON(data.authenticated_user),
    preferences: Preferences.fromJSON(null), // TODO
  }
}

export async function logout() {
  await del('/api/v1/auth/logout')
}
